import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { useDispatch } from 'react-redux';
import { SET_GENERIC } from 'store/actions';
import { selectGeneric } from 'store/app/selectors';
import { TaskAssignedSectionExpansionKey } from 'types/Tasks';

export const useTaskSectionExpanded = (
  key: TaskAssignedSectionExpansionKey,
): { expanded: boolean; toggle: () => void } => {
  const dispatch = useDispatch();
  const selectedValue = useSelector((state) => selectGeneric(state, key));
  const expanded = typeof selectedValue === 'boolean' ? selectedValue : true;

  const toggle = React.useCallback(() => {
    dispatch(
      SET_GENERIC({
        key,
        value: !expanded,
      }),
    );
  }, [dispatch, expanded, key]);

  return { expanded, toggle };
};
